export default __webpack_public_path__ + "static/media/FlagBrasil.14240b4a.png";